module.exports = __webpack_public_path__ + "static/media/iOS.e8284075.png";